import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Partnercard from "./PartnerCard";
import laptopImg from "../../Assets/partners.png";
import Toolstack from "./Toolstack";
import Card from "react-bootstrap/Card";
import { Trans, useTranslation } from "react-i18next";

function Partners() {
  const { t } = useTranslation();

  return (
    <Container fluid className="about-section partners-page">
      <Particle />
      <Container className="partners-container">
        <header className="partners-hero">
          <h1 className="partners-hero-title">
            <Trans i18nKey="aboutPartners.hero.title" components={{ purple: <strong className="purple" /> }} />
          </h1>
          <p className="partners-hero-lead">
            {t("aboutPartners.hero.lead")}
          </p>
        </header>

        <Row className="partners-top" style={{ justifyContent: "center" }}>
          <Col md={7} className="partners-left">
            <Partnercard />
          </Col>

          <Col md={5} className="partners-right">
            <div className="policy-card partners-image-card">
              <img src={laptopImg} alt={t("aboutPartners.a11y.imageAlt")} className="partners-image" />
            </div>
          </Col>
        </Row>

        <h2 className="partners-section-heading">
          <Trans i18nKey="aboutPartners.connect.heading" components={{ purple: <strong className="purple" /> }} />
        </h2>

        <Card className="policy-card partners-connect-card">
          <Card.Body>
            <blockquote className="blockquote mb-0">
              {(Array.isArray(t("aboutPartners.connect.items", { returnObjects: true }))
                ? t("aboutPartners.connect.items", { returnObjects: true })
                : []
              ).map((item, index, arr) => (
                <p
                  key={item.title}
                  className={`about-text partners-connect-paragraph${index === arr.length - 1 ? " partners-connect-paragraph-last" : ""}`}
                >
                  <span className="purple">{item.title}</span>
                  <br />
                  {item.body}
                </p>
              ))}
            </blockquote>
          </Card.Body>
        </Card>

        <h2 className="partners-section-heading">
          <Trans i18nKey="aboutPartners.partnersHeading" components={{ purple: <strong className="purple" /> }} />
        </h2>

        <Toolstack />
      </Container>
    </Container>
  );
}

export default Partners;
